import React from 'react';
import '../App.css';

export default function Yummers() {
  return (
    <div className="App">
      {/* Hero Section */}
      <header className="hero" style={{ position: 'relative' }}>
        <p className="tome-hero-eyebrow">Pick foods together</p>
        <h1 className="hero-title tome-hero-title">Yummers</h1>
        <p className="hero-subtitle">
          The smart way to decide where to eat with friends and partners.
        </p>
        <p style={{ fontSize: '1rem', color: '#c9c9dc', marginTop: '1rem', maxWidth: '600px', margin: '1rem auto' }}>
          Create a room, swipe through nearby restaurants, and discover where everyone agrees. No more indecision, just delicious choices.
        </p>
        <a href="https://yummers.lol" className="hero-button" target="_blank" rel="noopener noreferrer">
          Start Deciding Today
        </a>
        <div
          className="yummers-hero-watermark"
          style={{ backgroundImage: `url(/YummersPics/YummersLogo.png)` }}
        />
      </header>

      {/* Step-by-Step Tutorial Section */}
      <section className="services">
        <h2>Step-by-Step Tutorial</h2>

        {/* Step 1 */}
        <div style={{ marginBottom: '3rem', maxWidth: '800px', margin: '0 auto 3rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <div style={{ flex: '1', minWidth: '250px' }}>
              <h3 style={{ color: '#6bd4ff', fontSize: '1.5rem', marginBottom: '1rem' }}>
                Step 1: Create or Join
              </h3>
              <p style={{ fontSize: '1rem', color: '#c9c9dc', lineHeight: '1.6' }}>
                Start by creating a new room based on your location, or join an existing room using a code. Invite your friends or partner to join and get ready to find the perfect spot together.
              </p>
            </div>
            <div style={{
              flex: '1',
              minWidth: '250px',
              height: '250px',
              borderRadius: '1rem',
              overflow: 'hidden'
            }}>
              <img src="/YummersPics/BuildJoin.png" alt="Create or Join Room" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div style={{ marginBottom: '3rem', maxWidth: '800px', margin: '0 auto 3rem' }}>
          <div className="yummers-step-two" style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <div className="yummers-step-two-image" style={{
              flex: '1',
              minWidth: '250px',
              height: '250px',
              borderRadius: '1rem',
              overflow: 'hidden'
            }}>
              <img src="/YummersPics/Swipe.png" alt="Swipe & Explore" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div className="yummers-step-two-text" style={{ flex: '1', minWidth: '250px' }}>
              <h3 style={{ color: '#6bd4ff', fontSize: '1.5rem', marginBottom: '1rem' }}>
                Step 2: Swipe & Explore
              </h3>
              <p style={{ fontSize: '1rem', color: '#c9c9dc', lineHeight: '1.6' }}>
                Swipe left to skip a restaurant, or right to vote yes. Each card shows the restaurant name, address, and cuisine. (Images, Ratings, Pricing features are planned, but unfortunately costly) Tap to view directions, check out their website, or see more details before making your decision.
              </p>
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div style={{ marginBottom: '3rem', maxWidth: '800px', margin: '0 auto 3rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <div style={{ flex: '1', minWidth: '250px' }}>
              <h3 style={{ color: '#6bd4ff', fontSize: '1.5rem', marginBottom: '1rem' }}>
                Step 3: Top 3 Matches
              </h3>
              <p style={{ fontSize: '1rem', color: '#c9c9dc', lineHeight: '1.6' }}>
                Once everyone has swiped, see your top 3 restaurants: the ones you all (or most people) agreed on. Compare your finalists and make the final decision with confidence.
              </p>
            </div>
            <div style={{
              flex: '1',
              minWidth: '250px',
              height: '250px',
              borderRadius: '1rem',
              overflow: 'hidden'
            }}>
              <img src="/YummersPics/Top3.png" alt="Top 3 Matches" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services" style={{ paddingTop: '2rem', paddingBottom: '4rem' }}>
        <h2>Ready to Decide?</h2>
        <p style={{ fontSize: '1.1rem', color: '#c9c9dc', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem' }}>
          Stop the restaurant debate. Start using Yummers today and find the perfect spot in minutes.
        </p>
        <a href="https://yummers.lol" className="hero-button" target="_blank" rel="noopener noreferrer">
          Launch Yummers
        </a>
      </section>
    </div>
  );
}
